import React, { Component } from 'react';
import DefaultSwitch from '../Router/DefaultSwitch';
import RouterUtils from '../Router/RouterUtils';
import AuthorizeService from './AuthorizeService';
import { ApplicationPaths } from "./ApiAuthorizationConstants";
import RouterHistory from '../Router/RouterHistory';

export const Routes = {
  Profile: {
    path: ApplicationPaths.Profile,
    exact: true,
    render: function profile() {
      AuthorizeService.waitInitialization()
        .then(() => writeResult(JSON.stringify(AuthorizeService.user, null, 2)))
        .catch(() => writeResult('Initialization error'));
      return (<div id="result">Checking login state...</div>);
    },
  },
  Login: {
    path: ApplicationPaths.Login,
    exact: true,
    render: function login() {
      AuthorizeService.waitInitialization().then(() => {
        if (AuthorizeService.isAuthenticated()) {
          writeResult('Authenticated');
        } else {
          writeResult('Trying silent renew...');
          AuthorizeService.signIn(ApplicationPaths.LoginCallback);
        }
      });
      return (<div id="result">Checking login state...</div>);
    },
  },
  LoginCallback: {
    path: ApplicationPaths.LoginCallback,
    exact: true,
    render: function loginCallback() {
      AuthorizeService.waitInitialization().then(() => {
        AuthorizeService.completeRedirectSignIn().then(() => {
          if (AuthorizeService.isAuthenticated()) {
            writeResult('Authenticated');
          } else {
            writeResult('Login error');
          }
        }).catch(() => {
          writeResult('Login error');
        }).finally(() => {
          setTimeout(RouterHistory.push('/'), 5000);
        });
      }).finally(() => {
        setTimeout(RouterHistory.push('/'), 5000);
      });

      return (<div id="result">Processing login...</div>);
    },
  },
  LogOut: {
    path: ApplicationPaths.LogOut,
    exact: true,
    render: function logOut() {
      AuthorizeService.waitInitialization().then(() => {
        if (!AuthorizeService.isAuthenticated()) {
          writeResult('Already logout');
        } else {
          AuthorizeService.signOut();
          writeResult('Logout redirection...');
        }
      });
      return  (<div id="result">Logging out...</div>);
    },
  },
  LogOutCallback: {
    path: ApplicationPaths.LogOutCallback,
    exact: true,
    render: function logOutCallback() {
      AuthorizeService.waitInitialization().then(() => {
        AuthorizeService.subscribeOnce(() => {
          if (!AuthorizeService.isAuthenticated()) {
            writeResult('Logout success');
          } else {
            writeResult('Logout failure');
          }
        });
        AuthorizeService.completeSignOut()
          .finally(() => setTimeout(RouterHistory.push('/'), 5000));
      });
      return  (<div id="result">Processing logout...</div>);
    },
  }
};

class ApiAuthorizationRouter extends Component {
  render() {
    return (
      <DefaultSwitch>
        {RouterUtils.makeRoutes(Routes)}
      </DefaultSwitch>
    );
  }
}

function writeResult(msg) {
  let r = document.getElementById('result');
  if (r) {
    r.innerHTML = msg;
  }
}

export default ApiAuthorizationRouter;
